import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { AsmComponentsModule } from '@spartacus/asm/components'
import {AsmAdapter, AsmCoreModule} from '@spartacus/asm/core'
import { CsAgentAuthService } from '@spartacus/asm/root'
import { I18nModule, provideConfig } from '@spartacus/core'
import { FormErrorsModule } from '@spartacus/storefront'
import { EbAuthHttpHeaderService } from '../auth/services/eb-auth-http-header.service'
import { EbAsmAdapter } from './adapters/eb-asm.adapter'
import { EbAsmMainUiComponent } from './components/asm-main-ui/eb-asm-main-ui.component'
import { EbCustomerEmulationComponent } from './components/customer-emulation/eb-customer-emulation.component'
import { EbCustomerSelectionComponent } from './components/customer-selection/eb-customer-selection.component'
import { EbAsmAuthHttpHeaderService } from './services/eb-asm-auth-http-header.service'
import { EbCsagentAuthService } from './services/eb-csagent-auth.service'

@NgModule({
  declarations: [EbAsmMainUiComponent, EbCustomerSelectionComponent, EbCustomerEmulationComponent],
  imports: [I18nModule, CommonModule, AsmComponentsModule, FormErrorsModule, ReactiveFormsModule,AsmCoreModule ],
  providers: [
    provideConfig({
      launch: {
        ASM: {
          outlet: 'cx-storefront',
          component: EbAsmMainUiComponent
        }
      }
    }),
    { provide: EbAuthHttpHeaderService, useClass: EbAsmAuthHttpHeaderService },
    { provide: CsAgentAuthService, useClass: EbCsagentAuthService },
    { provide: AsmAdapter, useClass: EbAsmAdapter },
  ]
})
export class EbAsmModule {}
